import { useLocation } from "react-router-dom";

import ClientChatBox from "./ClientChatBox";
import ClientWallet from "./ClientWallet";
import ClientPaymentGatewayMethod from "./ClientPaymentGatewayMethod";
import ClientImageGenerator from "./ClientImageGenerator";
import ClientEdit from "./ClinetEdit";
import ClientPaymentFeedback from "./ClientPaymentFeedback";
import ClientChangePassword from "./ClientChangePassword";
import ClientTransactionList from "./ClientTransactionList";
import { Bot } from "lucide-react";

const ClientContentRouter = ({
  isLoading,
  error,
  conversations,
  headerTitle,
  selectedConversation,
  handleConversationClick,
  handleDeleteConversation,
  selectedMenu,
  username,
  userId,
  accessToken,
  name,
  isBotActive,
  toggleView,
  isChatBotVisible,
  isPaymentFeedback,
  isChangePassword,
  isTransactionList,
  welcomeMessage,
  isRoomLoading,
  onRoomCreated
}) => {
  const location = useLocation();
  const path = location.pathname;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          {/* دایره گرادیانت با آیکون Bot */}
          <div className="relative w-[60px] h-[60px] rounded-full bg-gradient-to-br from-teal-400 to-cyan-600 flex items-center justify-center text-white shadow-lg shadow-teal-500/40 ring-1 ring-teal-300/40">
            <Bot className="w-7 h-7 relative z-10" />
            {/* حلقه پالس */}
            <span className="absolute inset-0 rounded-full bg-teal-400/40 animate-ping" />
            {/* هاله درخشان */}
            <div className="absolute -inset-2 rounded-full bg-teal-500/20 blur-xl pointer-events-none" />
          </div>

          <p className="text-sm font-medium bg-gradient-to-l from-teal-600 to-cyan-600 dark:!from-teal-400 dark:!to-cyan-400 bg-clip-text text-transparent animate-pulse">
            در حال بارگذاری...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 flex items-center justify-center text-sm text-red-400">
        {error}
      </div>
    );
  }

  if (path.startsWith("/bot/wallet")) {
    return <ClientWallet />;
  }

  if (
    path.startsWith(
      "/bot/payment-gateway-method"
    )
  ) {
    return (
      <ClientPaymentGatewayMethod />
    );
  }

  if (path.startsWith("/bot/image")) {
    return <ClientImageGenerator />;
  }

  if (path.startsWith("/bot/edit")) {
    return <ClientEdit />;
  }

  if (
    path.startsWith(
      "/bot/client-change-password"
    )
  ) {
    return <ClientChangePassword />;
  }

  if (
    path.startsWith(
      "/bot/client-payment-feedback"
    )
  ) {
    return <ClientPaymentFeedback />;
  }

  if (
    path.startsWith(
      "/bot/client-transaction-list"
    )
  ) {
    return <ClientTransactionList />;
  }

  /*
   * Main chat
   *
   * Conversation list is now inside ClientSidebar.
   */
  return (
    <div className="flex-1 h-full min-w-0 w-full">
      <ClientChatBox
        toggleView={toggleView}
        selectedConversation={
          selectedConversation
        }
        partnerId={userId}
        name={name}
        accessToken={accessToken}
        username={username}
        isBotActive={isBotActive}
        welcomeMessage={welcomeMessage}
        isRoomLoading={isRoomLoading}
        onRoomCreated={onRoomCreated}
      />
    </div>
  );
};

export default ClientContentRouter;